export default {
  portfolio: {
    en: 'Portfolio',
    pt: 'Portifólio',
    he: 'במקרים',
  },

  resume: {
    en: 'Resume',
    pt: 'Currículo',
    he: 'קורות חיים',
  },

  book: {
    en: 'Book a call',
    pt: 'Agende uma conversa',
    he: 'Book a call',
  },
};
